import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SeoCourcePageListComponent } from './seo-cource-page-list/seo-cource-page-list.component';
import { SeoCourcePageCreateComponent } from './seo-cource-page-create/seo-cource-page-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: SeoCourcePageListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: SeoCourcePageCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'seo-cource-page-create/:id',
        component: SeoCourcePageCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SeoCourcePageRoutingModule { }
